(function () {
  'use strict';

  function all(selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  }

  var menuButton = document.querySelector('[data-menu-button]');
  var mobileNav = document.querySelector('[data-mobile-nav]');

  function closeMenu() {
    if (!menuButton || !mobileNav) return;
    mobileNav.hidden = true;
    menuButton.setAttribute('aria-expanded', 'false');
  }

  if (menuButton && mobileNav) {
    menuButton.addEventListener('click', function () {
      var opening = mobileNav.hidden;
      mobileNav.hidden = !opening;
      menuButton.setAttribute('aria-expanded', opening ? 'true' : 'false');
    });
    all('a', mobileNav).forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });
  }

  all('[data-language-selector]').forEach(function (selector) {
    selector.addEventListener('change', function () {
      if (selector.form) selector.form.submit();
    });
  });

  function clamp(value, minimum, maximum) {
    return Math.max(minimum, Math.min(maximum, value));
  }

  function easeInOut(value) {
    return value < 0.5
      ? 4 * value * value * value
      : 1 - Math.pow(-2 * value + 2, 3) / 2;
  }

  function initAssembly(root) {
    if (!root || root.dataset.assemblyInitialized === 'true') return;

    var sticky = root.querySelector('[data-assembly-sticky]');
    var drawing = root.querySelector('.drawing-sheet');
    var progress = root.querySelector('[data-assembly-progress]');
    var phase = root.querySelector('[data-assembly-phase]');
    var instruction = root.querySelector('[data-assembly-instruction]');
    var replay = root.querySelector('[data-assembly-replay]');
    var parts = all('[data-assembly-part]', root).map(function (element) {
      var range = (element.dataset.assemblyRange || '0,1').split(',');
      return {
        element: element,
        kind: element.dataset.assemblyPart,
        from: parseFloat(range[0]),
        to: parseFloat(range[1])
      };
    });

    if (!sticky || !drawing || !parts.length) return;

    root.dataset.assemblyInitialized = 'true';

    var enabled = root.dataset.assemblyEnabled !== 'false';
    var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var desktopQuery = window.matchMedia('(min-width: 961px) and (min-height: 720px)');
    var stickySupported = !!(window.CSS && CSS.supports && CSS.supports('position', 'sticky'));
    var phases = [
      [0, '01 · STRUCTURE'],
      [0.25, '02 · POWERTRAIN'],
      [0.55, '03 · WORKING PARTS'],
      [0.75, '04 · DOCUMENTATION'],
      [0.93, '05 · REFERENCE COMPLETE']
    ];
    var mode = '';
    var playing = false;
    var autoPlayed = false;
    var playRequest = 0;
    var scrubRequest = 0;
    var configureRequest = 0;
    var playToken = 0;
    var observer = null;

    function setProgress(value) {
      var amount = clamp(value, 0, 1);

      parts.forEach(function (part) {
        var duration = part.to - part.from;
        var local = duration > 0 ? clamp((amount - part.from) / duration, 0, 1) : (amount >= part.to ? 1 : 0);
        if (part.kind === 'draw') {
          part.element.style.strokeDashoffset = String(1 - local);
        } else {
          part.element.style.opacity = String(local);
        }
      });

      if (progress) progress.textContent = Math.round(amount * 100) + '%';
      if (phase) {
        for (var index = phases.length - 1; index >= 0; index -= 1) {
          if (amount >= phases[index][0]) {
            phase.textContent = phases[index][1];
            break;
          }
        }
      }

      root.dataset.assemblyProgress = amount.toFixed(3);
    }

    function setInstruction(text) {
      if (instruction) instruction.textContent = text;
    }

    function updateHeaderOffset() {
      var header = document.querySelector('.site-header');
      var height = header ? header.offsetHeight : 65;
      root.style.setProperty('--hero-header-offset', height + 'px');
    }

    function stopPlayback() {
      playToken += 1;
      playing = false;
      if (playRequest) cancelAnimationFrame(playRequest);
      playRequest = 0;
    }

    function playAssembly() {
      if (reduceQuery.matches || mode === 'static') {
        setProgress(1);
        return;
      }

      stopPlayback();
      playing = true;
      var token = playToken;
      var startedAt = 0;
      setProgress(0);

      function step(timestamp) {
        if (token !== playToken) return;
        if (!startedAt) startedAt = timestamp;
        var elapsed = Math.min((timestamp - startedAt) / 2200, 1);
        setProgress(easeInOut(elapsed));
        if (elapsed < 1) {
          playRequest = requestAnimationFrame(step);
        } else {
          playing = false;
          playRequest = 0;
        }
      }

      playRequest = requestAnimationFrame(step);
    }

    function currentScrollProgress() {
      var header = document.querySelector('.site-header');
      var headerHeight = header ? header.offsetHeight : 65;
      var rect = root.getBoundingClientRect();
      var denominator = Math.max(root.offsetHeight - sticky.offsetHeight, 1);
      return clamp((headerHeight - rect.top) / denominator, 0, 1);
    }

    function scheduleScrub() {
      if (mode !== 'scroll' || playing || scrubRequest) return;
      scrubRequest = requestAnimationFrame(function () {
        scrubRequest = 0;
        setProgress(currentScrollProgress());
      });
    }

    function drawingIsVisible() {
      var rect = drawing.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < window.innerHeight;
    }

    function startAutoIfReady() {
      if (mode !== 'auto' || autoPlayed || !drawingIsVisible()) return;
      autoPlayed = true;
      playAssembly();
    }

    function targetMode() {
      if (!enabled || reduceQuery.matches) return 'static';
      return desktopQuery.matches && stickySupported ? 'scroll' : 'auto';
    }

    function configureMode() {
      configureRequest = 0;
      updateHeaderOffset();
      var nextMode = targetMode();

      if (nextMode === mode) {
        if (mode === 'scroll') scheduleScrub();
        if (mode === 'auto') startAutoIfReady();
        return;
      }

      stopPlayback();
      mode = nextMode;
      autoPlayed = false;
      root.classList.add('assembly-ready');
      root.classList.toggle('is-scroll-mode', mode === 'scroll');
      root.classList.toggle('is-auto-mode', mode === 'auto');
      root.classList.toggle('is-static-mode', mode === 'static');
      root.dataset.assemblyMode = mode;

      if (mode === 'static') {
        setInstruction('ASSEMBLY COMPLETE');
        setProgress(1);
      } else if (mode === 'scroll') {
        setInstruction('SCROLL TO ASSEMBLE ↓');
        requestAnimationFrame(scheduleScrub);
      } else {
        setInstruction('ASSEMBLY PLAYS IN VIEW');
        setProgress(0);
        requestAnimationFrame(startAutoIfReady);
      }
    }

    function scheduleConfigure() {
      if (configureRequest) return;
      configureRequest = requestAnimationFrame(configureMode);
    }

    function handleScroll() {
      if (mode === 'scroll') scheduleScrub();
      if (mode === 'auto') startAutoIfReady();
    }

    function listenToQuery(query) {
      if (query.addEventListener) query.addEventListener('change', scheduleConfigure);
      else if (query.addListener) query.addListener(scheduleConfigure);
    }

    function stopListeningToQuery(query) {
      if (query.removeEventListener) query.removeEventListener('change', scheduleConfigure);
      else if (query.removeListener) query.removeListener(scheduleConfigure);
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) startAutoIfReady();
        });
      }, { threshold: 0.25 });
      observer.observe(drawing);
    }

    if (replay) replay.addEventListener('click', playAssembly);
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', scheduleConfigure, { passive: true });
    listenToQuery(reduceQuery);
    listenToQuery(desktopQuery);
    configureMode();

    root._assemblyCleanup = function () {
      stopPlayback();
      if (scrubRequest) cancelAnimationFrame(scrubRequest);
      if (configureRequest) cancelAnimationFrame(configureRequest);
      if (observer) observer.disconnect();
      if (replay) replay.removeEventListener('click', playAssembly);
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', scheduleConfigure);
      stopListeningToQuery(reduceQuery);
      stopListeningToQuery(desktopQuery);
      root.removeAttribute('data-assembly-initialized');
    };
  }

  all('[data-assembly-hero]').forEach(initAssembly);

  document.addEventListener('shopify:section:load', function (event) {
    all('[data-assembly-hero]', event.target).forEach(initAssembly);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    all('[data-assembly-hero]', event.target).forEach(function (root) {
      if (root._assemblyCleanup) root._assemblyCleanup();
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeMenu();
  });

  var selectorRoot = document.querySelector('[data-product-selector]');
  var inquiryModel = document.querySelector('[data-inquiry-model]');

  function setText(root, selector, value, fallback) {
    var element = root.querySelector(selector);
    if (element) element.textContent = value || fallback;
  }

  function selectMachine(card) {
    if (!selectorRoot || !card) return;
    all('[data-machine-card]', selectorRoot).forEach(function (item) {
      var active = item === card;
      item.classList.toggle('is-active', active);
      if (active) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    });

    var code = card.dataset.code || '';
    var title = card.dataset.title || '';
    setText(selectorRoot, '[data-product-code]', code, 'MODEL');
    setText(selectorRoot, '[data-product-width]', card.dataset.width, 'Confirm with quote');
    setText(selectorRoot, '[data-product-depth]', card.dataset.depth, 'Confirm with quote');
    setText(selectorRoot, '[data-product-hp]', card.dataset.hp, 'Engineering review');
    setText(selectorRoot, '[data-product-linkage]', card.dataset.linkage, 'Model dependent');
    setText(selectorRoot, '[data-product-weight]', card.dataset.weight, 'Confirm with quote');
    setText(selectorRoot, '[data-product-wear]', card.dataset.wear, 'Available with quote');

    var details = selectorRoot.querySelector('[data-product-link]');
    if (details) {
      details.href = card.dataset.url || '#inquiry';
      details.textContent = card.dataset.url ? 'FULL DETAILS →' : 'REQUEST DATASHEET →';
    }
    var quote = selectorRoot.querySelector('[data-product-quote]');
    if (quote) quote.textContent = 'REQUEST QUOTE — ' + (code || title);
    if (inquiryModel) inquiryModel.value = (code ? code + ' — ' : '') + title;
  }

  if (selectorRoot) {
    all('[data-machine-card]', selectorRoot).forEach(function (card) {
      card.addEventListener('click', function () { selectMachine(card); });
    });
    var firstCard = selectorRoot.querySelector('[data-machine-card]');
    if (firstCard) selectMachine(firstCard);
  }

  var fitRoot = document.querySelector('[data-project-fit]');
  if (fitRoot) {
    var power = fitRoot.querySelector('[data-fit-power]');
    var depth = fitRoot.querySelector('[data-fit-depth]');
    var output = fitRoot.querySelector('[data-fit-depth-output]');
    var addRequirement = fitRoot.querySelector('[data-fit-inquiry]');
    var inquiryPower = document.querySelector('[data-inquiry-power]');
    var inquiryRequirement = document.querySelector('[data-inquiry-requirement]');

    function updateDepth() {
      if (depth && output) output.textContent = depth.value;
    }
    if (depth) depth.addEventListener('input', updateDepth);
    updateDepth();

    if (addRequirement) {
      addRequirement.addEventListener('click', function () {
        if (inquiryPower && power) inquiryPower.value = power.value;
        if (inquiryRequirement && depth) {
          var note = 'Target working depth: ' + depth.value + ' mm.';
          if (inquiryRequirement.value.indexOf(note) === -1) {
            inquiryRequirement.value = inquiryRequirement.value ? inquiryRequirement.value + '\n' + note : note;
          }
        }
      });
    }
  }
})();
